import dayjs from "dayjs";
import Card from "../../../components/Card";

export default function RecentActivityGrid({ activity }) {
  if (!activity) return null;
  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
      <Card>
        <h3 className="text-lg font-semibold mb-4 text-text">Recent Bookings</h3>
        <div className="space-y-2">
          {activity.bookings?.slice(0, 5).map((booking) => (
            <div key={booking._id} className="text-sm">
              <p className="font-medium text-text">{booking.subjectId?.name}</p>
              <p className="text-text opacity-60 text-xs">{dayjs(booking.createdAt).format("MMM D, h:mm A")}</p>
            </div>
          ))}
        </div>
      </Card>
      <Card>
        <h3 className="text-lg font-semibold mb-4 text-text">Recent Sessions</h3>
        <div className="space-y-2">
          {activity.sessions?.slice(0, 5).map((session) => (
            <div key={session._id} className="text-sm">
              <p className="font-medium text-text">{session.subjectId?.name}</p>
              <p className="text-text opacity-60 text-xs">{dayjs(session.createdAt).format("MMM D, h:mm A")}</p>
            </div>
          ))}
        </div>
      </Card>
      <Card>
        <h3 className="text-lg font-semibold mb-4 text-text">New Users</h3>
        <div className="space-y-2">
          {activity.users?.slice(0, 5).map((user) => (
            <div key={user._id} className="text-sm">
              <p className="font-medium text-text">{user.name?.first} {user.name?.last}</p>
              <p className="text-text opacity-60 text-xs capitalize">{user.role} • {dayjs(user.createdAt).format("MMM D")}</p>
            </div>
          ))}
        </div>
      </Card>
    </div>
  );
}
